module.exports = __webpack_public_path__ + "static/media/wentworth.054e41d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/experiences/wentworth.png
// module id = 101
// module chunks = 0